/*!
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Node } from '@alfresco/js-api';
import { isLocked, NodePermissionService } from '@alfresco/aca-shared';
import { MatCardModule } from '@angular/material/card';
import { RcComments } from '../rc-comments/rc-comments';

/**
 * Onglet "Commentaires" du panneau d'information.
 *
 * Remplace l'onglet natif d'ACA (`adf-node-comments`) par notre composant `rc-comments`.
 * L'override se fait par identifiant de composant depuis AlgExtensionsModule :
 *
 *     extensions.setComponents({ 'app.components.tabs.comments': AlgCommentsTabComponent })
 *
 * Aucun fichier d'ACA n'est modifie — voir docs/fork/README.md §7.
 */
@Component({
  standalone: true,
  imports: [MatCardModule, RcComments],
  selector: 'alg-comments-tab',
  template: `<mat-card><rc-comments [readOnly]="!canUpdateNode" [nodeId]="node?.id"></rc-comments></mat-card>`,
  encapsulation: ViewEncapsulation.None
})
export class AlgCommentsTabComponent implements OnInit {
  @Input()
  node: Node;

  canUpdateNode = false;

  constructor(private permission: NodePermissionService) {}

  ngOnInit(): void {
    if (!this.node) {
      this.canUpdateNode = false;
      return;
    }
    if (this.node.isFolder || (this.node.isFile && !isLocked({ entry: this.node }))) {
      this.canUpdateNode = this.permission.check(this.node, ['update']);
    }
  }
}
